import * as React from "react"
import {
  footerStyle,
  copyright,
} from "./footer.module.css"

export function Footer() {
  return (
    <footer className={footerStyle}>
      <nav aria-label="footer">
        {/* <p>
          Socials: &nbsp;
          <a href="https://www.instagram.com/robertellismusic/" type="instagram" duration="6s" delay="-1s">Instagram</a> &nbsp;/&nbsp;
          <a href="https://twitter.com/robertellis_" type="twitter" duration="5s" delay="-.5s">Twitter</a> &nbsp;/&nbsp;
          <a href="https://www.facebook.com/robertellismusic" type="facebook" duration="7.5s" delay="-2s" width="65%">Facebook</a>
        </p> */}
        <p>&nbsp;</p>
        <p>
          Management: <a href="mailto:cara@tenatoms.com">cara@tenatoms.com</a><br />
          Booking (US &amp; AUS): <a href="mailto:afang@newfrontiertouring.com">afang@newfrontiertouring.com</a><br />
          Booking (UK &amp; EU): <a href="mailto:gijs@sedate-bookings.com">gijs@sedate-bookings.com</a>
        </p>

      </nav>
      <div className={copyright}>
        Copyright &copy; {new Date().getFullYear()} · All rights reserved
      </div>
    </footer>
  )
}
